import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class OriginalGoodsItem extends PureComponent {
  _go = () => {
    const { history } = this.props;
    const { index } = this.props.childProps;
    window.scrollTo(0, 0);
    history.push('storeOriginalGoods?i=' + index);
  };
  render() {
    const { listImg, title, index } = this.props.childProps;
    return (
      <Fragment>
        <li className="store_orgin_item" onClick={this._go}>
          {/* 오리지널 굿즈 */}
          <div className="orgin_goods">
            {index <= 2 ? <div className="ico_new">new</div> : null}

            <div className="thumb">
              <img src={listImg} alt="" />
            </div>
            <div className="subject">{title}</div>
          </div>
        </li>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(OriginalGoodsItem)));
